import { api, ApiError } from "@/api/api";
import { Prompt, UpdatePrompt } from "@/api/prompts-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Variables = {
  promptId: string;
  data: UpdatePrompt;
};

export function useUpdatePrompt() {
  const queryClient = useQueryClient();
  return useMutation<Prompt, ApiError, Variables>({
    mutationKey: ["PATCH", "promptDetails"],
    mutationFn: (variables: Variables) =>
      api.prompts.promptId.patch(variables.promptId, variables.data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["GET", "promptDetails", variables.promptId],
      });
      queryClient.invalidateQueries({ queryKey: ["GET", "prompts"] });
    },
  });
}
